import moment from 'moment';
import _filter from 'lodash/filter';

import admissionGroupStatService from 'src/api/admissionGroupStat';
import ADMISSION_GROUP_TYPES from 'constants/admissionGroupTypes';

const ALL_VENUES_ID = 'ALL_VENUES_ID';

function PerformanceCtrl($scope, $state, $stateParams, permissionService, $q, organizationService, venueService, alertService, sdkUtils) {
  const currentUserOrganization = organizationService.getCurrentOrganization();

  $scope.queryParams = $stateParams;
  $scope.filterUsersForm = {
    venue: null,
    attributionSource: null
  };

  $scope.getPageTitle = function() {
    if ($state.current.name === 'app.organization.performance.payouts') return 'Performance - Payouts';
    if ($state.current.name === 'app.organization.performance.stats') return 'Performance - Stats';
    if ($state.current.name === 'app.organization.performance.reservations') return 'Performance - Reservations';
    if ($state.current.name === 'app.organization.performance.guestlist') return 'Performance - Guestlist';
    if ($state.current.name === 'app.organization.performance.exportList') return 'Performance - Exports';
    return 'Performance';
  };

  $scope.getAdmissionGroupStatsByVenueId = function(venueId, dateStart, dateEnd, options = {}) {
    $scope.admissionGroupStatsLoading = true;

    return permissionService.canWriteVenue(venueId)
      .then(hasPermission => {
        if (!hasPermission) {
          $scope.canViewStats = false;
          return null;
        }

        $scope.canViewStats = true;

        return $q.resolve(admissionGroupStatService.findByIdAndVenueId(dateStart.format('x'), venueId, {
            type: options.type,
            dateEnd: dateEnd.format('x'),
            attributionId: options.attributionId || undefined
          }))
          .then(mapAdmissionGroupStatsResults);
      });
  };

  $scope.getAdmissionGroupStatsByOrganizationId = function(dateStart, dateEnd, options = {}) {
    $scope.admissionGroupStatsLoading = true;

    let venues = [].concat($scope.venues);

    const permissionPromises = $scope.venues.map(venue => {
      return permissionService.canReadPerformanceReports(venue.id)
        .then(hasPermission => {
          if (!hasPermission) {
            venues = _filter(venues, v => {
              return v.id !== venue.id;
            });
          }
        });
    });

    return Promise.all(permissionPromises)
      .then(() => {
        if (!venues || !venues.length) {
          $scope.canViewStats = false;
          return null;
        }

        $scope.canViewStats = true;

        return $q.resolve(admissionGroupStatService.findByIdAndOrganizationId(dateStart.format('x'), currentUserOrganization.id, {
            venueId: venues.map(v => v.id),
            type: options.type,
            dateEnd: dateEnd.format('x'),
            attributionId: options.attributionId || undefined
          }))
          .then(mapAdmissionGroupStatsResults);
      });
  };

  function mapAdmissionGroupStatsResults(result) {
    $scope.admissionGroupStats = result.data;
    $scope.admissionGroupStatsTotals = result.data.totals;
    $scope.admissionGroupStatsByUser = result.data.totalsByUser;
    $scope.admissionGroupStatsByDate = result.data.totalsByDate;
    $scope.admissionGroupStats.modified = moment($scope.admissionGroupStats.modified, 'x');

    $scope.reservationStats = {
      type: ADMISSION_GROUP_TYPES.TABLE,
      totalExpected: $scope.admissionGroupStatsTotals.totalExpectedReservations,
      total: $scope.admissionGroupStatsTotals.totalReservations,
      totalPrepaidSubtotal: $scope.admissionGroupStatsTotals.totalPrepaidReservationSubtotal,
      totalPrepaidProcessingFeeTotal: $scope.admissionGroupStatsTotals.totalPrepaidReservationProcessingFeeTotal,
      totoalPrepaidCommission: $scope.admissionGroupStatsTotals.totalPrepaidReservationCommission,
      totalPrepaidVenuePayout: $scope.admissionGroupStatsTotals.totalPrepaidReservationVenuePayout,
      totalPrepaidTotal: $scope.admissionGroupStatsTotals.totalPrepaidReservationTotal,
      totalExpectedSpent: $scope.admissionGroupStatsTotals.totalExpectedReservationSpent,
      totalSpent: $scope.admissionGroupStatsTotals.totalReservationSpent,
      totalExpectedGuests: $scope.admissionGroupStatsTotals.totalReservationExpectedGuests,
      totalGuests: $scope.admissionGroupStatsTotals.totalReservationGuests
    };

    $scope.admissionStats = {
      totalExpected: $scope.admissionGroupStatsTotals.totalExpectedAdmissions,
      total: $scope.admissionGroupStatsTotals.totalAdmissions,
      totalPrepaidSubtotal: $scope.admissionGroupStatsTotals.totalPrepaidAdmissionSubtotal,
      totalPrepaidProcessingFeeTotal: $scope.admissionGroupStatsTotals.totalPrepaidAdmissionProcessingFeeTotal,
      totoalPrepaidCommission: $scope.admissionGroupStatsTotals.totalPrepaidAdmissionCommission,
      totalPrepaidVenuePayout: $scope.admissionGroupStatsTotals.totalPrepaidAdmissionVenuePayout,
      totalPrepaidTotal: $scope.admissionGroupStatsTotals.totalPrepaidAdmissionTotal,
      totalExpectedSpent: $scope.admissionGroupStatsTotals.totalExpectedAdmissionSpent,
      totalSpent: $scope.admissionGroupStatsTotals.totalAdmissionSpent,
      totalExpectedGuests: $scope.admissionGroupStatsTotals.totalAdmissionExpectedGuests,
      totalGuests: $scope.admissionGroupStatsTotals.totalAdmissionGuests
    };

    $scope.coverStats = {
      type: ADMISSION_GROUP_TYPES.GUEST_LIST,
      totalExpected: $scope.admissionGroupStatsTotals.totalExpectedCovers,
      total: $scope.admissionGroupStatsTotals.totalCovers,
      totalPrepaidSubtotal: $scope.admissionGroupStatsTotals.totalPrepaidCoverSubtotal,
      totalPrepaidProcessingFeeTotal: $scope.admissionGroupStatsTotals.totalPrepaidCoverProcessingFeeTotal,
      totoalPrepaidCommission: $scope.admissionGroupStatsTotals.totalPrepaidCoverCommission,
      totalPrepaidVenuePayout: $scope.admissionGroupStatsTotals.totalPrepaidCoverVenuePayout,
      totalPrepaidTotal: $scope.admissionGroupStatsTotals.totalPrepaidCoverTotal,
      totalExpectedSpent: $scope.admissionGroupStatsTotals.totalExpectedCoverSpent,
      totalSpent: $scope.admissionGroupStatsTotals.totalCoverSpent,
      totalExpectedGuests: $scope.admissionGroupStatsTotals.totalExpectedCoverGuests,
      totalGuests: $scope.admissionGroupStatsTotals.totalCoverGuests
    };

    $scope.guestlistStats = {
      type: ADMISSION_GROUP_TYPES.GUEST_LIST,
      totalExpected: $scope.admissionGroupStatsTotals.totalExpectedGuestlists,
      total: $scope.admissionGroupStatsTotals.totalGuestlists,
      totalPrepaidSubtotal: $scope.admissionGroupStatsTotals.totalPrepaidGuestlistSubtotal,
      totalPrepaidProcessingFeeTotal: $scope.admissionGroupStatsTotals.totalPrepaidGuestlistProcessingFeeTotal,
      totoalPrepaidCommission: $scope.admissionGroupStatsTotals.totalPrepaidGuestlistCommission,
      totalPrepaidVenuePayout: $scope.admissionGroupStatsTotals.totalPrepaidGuestlistVenuePayout,
      totalPrepaidTotal: $scope.admissionGroupStatsTotals.totalPrepaidGuestlistTotal,
      totalExpectedSpent: $scope.admissionGroupStatsTotals.totalExpectedGuestlistSpent,
      totalSpent: $scope.admissionGroupStatsTotals.totalGuestlistSpent,
      totalExpectedGuests: $scope.admissionGroupStatsTotals.totalExpectedGuestlistGuests,
      totalGuests: $scope.admissionGroupStatsTotals.totalGuestlistGuests
    };

    $scope.ticketStats = {
      type: ADMISSION_GROUP_TYPES.TICKET,
      totalExpected: $scope.admissionGroupStatsTotals.totalExpectedTallies,
      total: $scope.admissionGroupStatsTotals.totalTickets,
      totalPrepaidSubtotal: $scope.admissionGroupStatsTotals.totalPrepaidTicketSubtotal,
      totalPrepaidProcessingFeeTotal: $scope.admissionGroupStatsTotals.totalPrepaidTicketProcessingFeeTotal,
      totoalPrepaidCommission: $scope.admissionGroupStatsTotals.totalPrepaidTicketCommission,
      totalPrepaidVenuePayout: $scope.admissionGroupStatsTotals.totalPrepaidTicketVenuePayout,
      totalPrepaidTotal: $scope.admissionGroupStatsTotals.totalPrepaidTicketTotal,
      totalExpectedSpent: $scope.admissionGroupStatsTotals.totalExpectedTicketSpent,
      totalSpent: $scope.admissionGroupStatsTotals.totalTicketSpent,
      totalExpectedGuests: $scope.admissionGroupStatsTotals.totalExpectedTicketGuests,
      totalGuests: $scope.admissionGroupStatsTotals.totalTicketGuests
    };

    $scope.tallyStats = {
      type: ADMISSION_GROUP_TYPES.TALLY,
      total: $scope.admissionGroupStatsTotals.totalTallies,
      totalPrepaidSubtotal: $scope.admissionGroupStatsTotals.totalPrepaidTallySubtotal,
      totoalPrepaidCommission: $scope.admissionGroupStatsTotals.totalPrepaidTallyCommission,
      totalPrepaidVenuePayout: $scope.admissionGroupStatsTotals.totalPrepaidTallyVenuePayout,
      totalPrepaidTotal: $scope.admissionGroupStatsTotals.totalPrepaidTallyTotal,
      totalExpectedSpent: $scope.admissionGroupStatsTotals.totalExpectedTallySpent,
      totalSpent: $scope.admissionGroupStatsTotals.totalTallySpent,
      totalExpectedGuests: $scope.admissionGroupStatsTotals.totalExpectedTallyGuests,
      totalGuests: $scope.admissionGroupStatsTotals.totalTallyGuests
    };

    $scope.stats = [
      $scope.reservationStats,
      $scope.coverStats,
      $scope.ticketStats
    ];

    $scope.admissionGroupStatsLoading = false;
  }

  function _getVenues() {
    return venueService.listByOrganizationId(currentUserOrganization.id, {
        fields: 'name, id'
      })
      .then(venues => {
        const permissionPromises = venues.map(venue => {
          return permissionService.canReadPerformanceReports(venue.id)
            .then(hasPermission => {
              if (!hasPermission) {
                venues = _filter(venues, v => {
                  return v.id !== venue.id;
                });
              }
            });
        });

        return $q.all(permissionPromises)
          .then(() => {
            $scope.venues = venues;

            $scope.venues.unshift({
              id: ALL_VENUES_ID,
              name: 'All Venues'
            });

            return venues;
          });
      })
      .catch(response => {
        alertService.error(sdkUtils.getErrorFromResponse(response));
      });
  }

  $scope.venuesPromise = _getVenues();
}

PerformanceCtrl.$inject = [
  '$scope',
  '$state',
  '$stateParams',
  'permissionService',
  '$q',
  'organizationService',
  'jsSdk.venue',
  'alertService',
  'jsSdk.utils'
];

export default PerformanceCtrl;



// WEBPACK FOOTER //
// ./src/components/performance/performanceCtrl.js